module.exports = __webpack_public_path__ + "static/media/loading-animation.2b0e48f2.webm";